import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthApiService } from '../../services/auth-api.service';

@Component({
  selector: 'app-solicitar-cadastro',
  templateUrl: './solicitar-cadastro.component.html',
  styleUrl: './solicitar-cadastro.component.scss',
  standalone: false,
})
export class SolicitarCadastroComponent implements OnInit {

  form: FormGroup;

  loading = false;
  cadastroEnviado = false;
  erroConflito = false;
  erroGenerico = false;

  constructor(
    private fb: FormBuilder,
    private authApiService: AuthApiService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      login: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      senha: ['', Validators.required],
      confirmacaoSenha: ['', Validators.required],
    });
  }

  get senhasNaoConferem(): boolean {
    const { senha, confirmacaoSenha } = this.form.value;
    return !!confirmacaoSenha && senha !== confirmacaoSenha;
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    if (this.senhasNaoConferem) {
      return;
    }

    this.loading = true;
    this.erroConflito = false;
    this.erroGenerico = false;

    const { login, email, senha } = this.form.value;

    this.authApiService.cadastro(login!, email!, senha!).subscribe({
      next: () => {
        this.cadastroEnviado = true;
        this.loading = false;
      },
      error: (err) => {
        if (err.status === 409) {
          this.erroConflito = true;
        } else {
          this.erroGenerico = true;
        }
        this.loading = false;
      },
    });
  }

  isInvalid(campo: string): boolean {
    const control = this.form.get(campo);
    return !!control && control.invalid && control.touched;
  }
}
